import { render, staticRenderFns } from "./BerthMaster.vue?vue&type=template&id=8d4870d6&scoped=true&"
import script from "./BerthMaster.vue?vue&type=script&lang=js&"
export * from "./BerthMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4870d6",
  null
  
)

export default component.exports